import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { userActions } from '_actions';
import { CompanySelectionListItem } from 'LoginPage';
import styles from './CompanySelectionPanel.module.css'

class CompanySelectionPanel extends React.Component {
    render() {
        if ((this.props.availableCompanies ? this.props.availableCompanies.length : 0) > 0) {
            return (
                <div className={styles.wrapper}>
                    <h2 className={styles.header}>Select a Company</h2>
                    <ul>
                        {Object.keys(this.props.availableCompanies)
                            .map(key => {
                                const company = this.props.availableCompanies[key];
                                return <CompanySelectionListItem
                                    key={company.companyId}
                                    id={company.companyId}
                                    name={company.name}
                                    selectCompany={this.props.selectCompany}
                                />
                            })
                        }
                    </ul>
                </div>
            );
        }
        else {
            return (<h2 className={styles.header}>No available companies.</h2>);
        }
    }
}


function mapStateToProps(state) {
    return {
        availableCompanies: state.entities.authentication.user ? state.entities.authentication.user.availableCompanies : {}
    };
}

function mapDispatchToProps(dispatch) {
    return {
        selectCompany: bindActionCreators(userActions.selectCompany, dispatch)
    };
}

const connectedCompanySelectionPanel = connect(mapStateToProps, mapDispatchToProps)(CompanySelectionPanel);
export { connectedCompanySelectionPanel as CompanySelectionPanel }; 